<modeso-product-detail [productId]="productId$ | async">
  <lidl-lib-cart-fe-add-to-cart add-to-cart [product]="cartProduct" (productNotificationEvent)="handleProductNotificationEvent($event)"
    [caption]="'modeso_cart_add-to-cart-button_caption' | localize | async">
  </lidl-lib-cart-fe-add-to-cart>
  <div notification-message class="col-lg-12 notification-message" [ngClass]="{'display-success': (!hasError && showNotification), 'display-error': (hasError && showNotification)}">
    <span> {{ notificationMessage | localize | async }}</span>
    <a (click)="navigateToCart()"> {{'modeso_cart_added-to-cart_go-to-cart' | localize | async}} </a>
  </div>
</modeso-product-detail>
